/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentQueueEmpty/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AppointmentQueueEmpty({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/RescheduleQueue/AppointmentQueueEmpty"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabSelectedAppointmentQueueValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.appointment_queue',
format: fromFormat.isEmptyList,
})
let tabIsDraggingTimegridAppointmentValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'is_dragging_timegrid_appointment',
format: fromFormat.not,
})
let aggregateData = fromAggregate.and(tabSelectedAppointmentQueueValueData, tabIsDraggingTimegridAppointmentValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}